module.exports = __webpack_public_path__ + "img/prize8.47dd33e2.jpg";